import React from 'react';
import { WrenchIcon, XIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { OfferBlock } from '../OfferBlock';
const costs = ['a far pagare senza processi', 'a perdere tempo', 'a cercare documenti', 'a improvvisare preventivi', 'a lasciare opportunità sul tavolo'];
export function FinalCta() {
  return <section className="bg-ink-900" data-id="element-119" data-mp="1sm8856wvyu7y">
      <div className="mx-auto w-full max-w-xl px-4 py-12 sm:py-16 lg:max-w-3xl" data-id="element-120" data-mp="1eojlpun67f0s">
        <h2 className="text-center font-display text-[26px] uppercase leading-[1.1] text-white sm:text-3xl lg:text-[40px]" data-id="element-121" data-mp="1eqnyl231rod7">
          🚀 Oggi puoi continuare a improvvisare…
          <span className="mt-2 block text-accent" data-id="element-122" data-mp="14rygb878o1wf">oppure installare il sistema.</span>
        </h2>

        <p className="mx-auto mt-5 max-w-xl text-center text-[15px] leading-relaxed text-white/65 sm:text-base" data-id="element-123" data-mp="19pgsd7gjyx8n">
          Lo stesso sistema che sta già aiutando migliaia di tecnici a lavorare con più ordine,
          trasmettere maggiore fiducia e dedicare meno tempo alla burocrazia.
        </p>

        <div className="mt-8 rounded-2xl border border-white/10 bg-ink-800 p-5 sm:p-6" data-id="element-124" data-mp="27aaqjqeg9ke">
          <p className="text-[14px] font-semibold text-white sm:text-[15px]" data-id="element-125" data-mp="3tewjgqrz7284">
            Ogni giorno che rimandi l’organizzazione della tua attività è un altro giorno passato:
          </p>
          <ul className="mt-4 space-y-2.5" data-id="element-126" data-mp="714oz7n8jwc3">
            {costs.map(cost => <li key={cost} className="flex items-start gap-2.5" data-id="element-127" data-mp="3feva0mxnamh1">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-danger/20" data-id="element-128" data-mp="3agjzsb3fu9ya">
                  <XIcon className="h-3 w-3 text-danger" aria-hidden="true" data-id="element-129" data-mp="3ogurthghhul1" />
                </span>
                <span className="text-[14px] leading-snug text-white/70 sm:text-[15px]" data-id="element-130" data-mp="3jgqj4dlti45d">{cost}</span>
              </li>)}
          </ul>
        </div>

        <div className="mt-9 space-y-5" data-id="element-131" data-mp="13s6wlxav43lo">
          <div className="flex items-center justify-center gap-2" data-id="element-132" data-mp="yrsqwlwqh5qt">
            <WrenchIcon className="h-5 w-5 text-accent" aria-hidden="true" data-id="element-133" data-mp="3sizgqn641wzr" />
            <span className="font-display text-sm uppercase tracking-wide text-white sm:text-base" data-id="element-134" data-mp="3siplak2aqxmo">
              Sistema Tecnico PRO 360™
            </span>
          </div>
          <CtaButton label="Voglio il Sistema Tecnico PRO 360™ — 19 €" size="lg" note="Accesso a vita · Garanzia di 7 giorni" data-id="element-135" data-mp="5fkxwgmqaqbu" />
          <OfferBlock data-id="element-136" data-mp="39t16c0eubrsy" />
        </div>
      </div>
    </section>;
}